<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="heading-ul mb-3">
          <div class="flex mt-2">
            <router-link to="/inventory/stocktransfer" class="mr-2">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
            <h3>{{ $t("inventory.label.CreateItemSale") }}</h3>
          </div>
        </div>
      </div>
      <ValidationObserver ref="observer">
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("inventory.label.Purchase Date")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Purchase Date')"
                  >
                    <datepicker
                      v-model="purchaseDate"
                      :placeholder="$t('placeholder.label.SelectDate')"
                      class="mb-2 font-semibold"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("inventory.label.Item") }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Item')"
                  >
                    <v-select
                      label="item"
                      v-model="selectedItem"
                      :options="itemList"
                      @input="selectedFirstItems(selectedItem)"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="mb-2"
                    >
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("inventory.label.PurchasedFrom")
                    }}<span class="required"> *</span></small
                  >
                  <vue-simple-suggest
                    v-model="loc"
                    :list="locList"
                    @input="testMethod2()"
                    class="w-full font-normal mb-2"
                    :filter-by-query="true"
                  >
                    <div slot="suggestion-item" slot-scope="{ suggestion }">
                      <span @click="changeLoc(suggestion.id)"
                        >{{ suggestion.externalId }} --
                        {{ suggestion.name }}</span
                      >
                    </div>
                  </vue-simple-suggest>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("inventory.label.PurchaseBy")
                    }}<span class="required"> *</span></small
                  >

                  <vue-simple-suggest
                    v-model="loc1"
                    :list="locList"
                    @input="testMethod3()"
                    class="w-full font-normal mb-2"
                    :filter-by-query="true"
                  >
                    <div slot="suggestion-item" slot-scope="{ suggestion }">
                      <span @click="changeLoc1(suggestion.id)"
                        >{{ suggestion.externalId }} --
                        {{ suggestion.name }}</span
                      >
                    </div>
                  </vue-simple-suggest>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("inventory.label.Charge") }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Charge')"
                  >
                    <v-select
                      label="item"
                      v-model="selectedCharge"
                      :options="chargeList"
                      @input="selectedItems(selectedCharge)"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.item
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('stockTransfer.label.Ordered Quantity')"
                >
                  <vs-input
                    :label="$t('stockTransfer.label.Ordered Quantity')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="orderQuantity"
                    type="number"
                    @input="orderQuantityChange"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('inventory.label.UnitPrice')"
                >
                  <vs-input
                    :label="$t('inventory.label.UnitPrice')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="onetimesalesItem.unitPrice"
                    @input="orderQuantityChange"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <vs-input
                  :label="$t('inventory.label.TotalItemPrice')"
                  class="w-full mb-4 font-semibold"
                  v-model="chargeAmount"
                  disabled
                />
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label">{{ $t("inventory.label.DiscountType") }}</small>
                  <v-select
                    label="item"
                    v-model="Percentage"
                    :options="percentageOption"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    class="mb-2"
                    disabled
                  >
                  </v-select>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('inventory.label.DiscountRate')"
                >
                  <vs-input
                    :label="$t('inventory.label.DiscountRate')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="discount"
                    @input="orderQuantityChange"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full">
          <div class="saveCancelBtn mb-3">
            <vs-button type="border" @click="backToGoods"
              >{{ $t("inventory.label.Reset") }}
            </vs-button>
            <vs-button :disabled="!loc || !loc1" @click="CreateItemSale">{{
              $t("inventory.label.Submit")
            }}</vs-button>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import moment from "moment";
import {
  itemSaleTemplateResource,
  getMrnFalse,
  getMrnTrue,
  getOneTimeSaleItem,
  getTotalPricePost,
  postItemSale,
} from "@/http/inventory";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data() {
    return {
      purchaseDate: moment().format("DD MMMM YYYY"),
      chargeCode: "",
      itemId: 0,
      loc: "",
      loc1: "",
      unitPrice: 0,
      itemDatas: [],
      chargeDatas: {},
      itemSales: {},
      onetimesalesItem: {},
      chargeList: [],
      itemList: [],
      fromOffice: "",
      purchaseFrom: 0,
      purchaseBy: 0,
      toOffice: "",
      selectedCharge: "",
      selectedItem: "",
      Percentage: "Percentage",
      percentageOption: ["Percentage"],
      orderQuantity: "",
      PriceData: "",
      chargeAmount: "",
      discount: "",
      currencyId: "",
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      entity: {
        officeId: "",
        toofficeId: "",
      },
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    VueSimpleSuggest,
    moment,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      locList: (state) => state.entity.locationList,
    }),
  },

  methods: {
    testMethod2() {
      let temp = this.loc;
      if (temp.includes("{")) {
        temp = JSON.parse(temp);

        if (typeof temp === "object") {
          this.loc = temp.externalId + "--" + temp.name;
          this.entity.officeId = temp.id;
        }
      } else {
        this.$store.dispatch("entity/entityGetLocationAction", this.loc);
      }
    },
    testMethod3() {
      let temp = this.loc1;
      if (temp.includes("{")) {
        temp = JSON.parse(temp);

        if (typeof temp === "object") {
          this.loc1 = temp.externalId + "--" + temp.name;
          this.entity.toofficeId = temp.id;
        }
      } else {
        this.$store.dispatch("entity/entityGetLocationAction", this.loc1);
      }
    },
    async itemSaleTemplateResource() {
      try {
        const response = await itemSaleTemplateResource();
        this.itemSales = response.data;
      } catch (e) {
        console.log("something went to wrong while details:", e);
      }
    },

    async getMrnTrue() {
      try {
        const response = await getMrnTrue(this.fromOffice);
        return response.data.officeData;
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    async getMrnFalse() {
      try {
        const response = await getMrnFalse(this.toOffice);
        return response.data.officeData;
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    changeCollectiontrue(e) {
      this.purchaseFrom = e.id;
    },
    changeCollectionfalse(e) {
      this.purchaseBy = e.id;
    },

    async selectedFirstItems(off) {
      this.itemSales.itemDatas.map((e) => {
        if (e.itemCode + " -- " + e.itemDescription == off) {
          this.itemId = e.id;
        }
      });
      try {
        const response = await getOneTimeSaleItem(this.itemId);
        this.onetimesalesItem = response.data;
        this.unitPrice = response.data.unitPrice;
        this.chargeList.push(
          this.onetimesalesItem &&
            this.onetimesalesItem.chargesData[0] &&
            this.onetimesalesItem.chargesData[0].chargeCode +
              "--" +
              this.onetimesalesItem &&
            this.onetimesalesItem.chargesData[0] &&
            this.onetimesalesItem.chargesData[0].chargeDescription
        );
        this.selectedCharge =
          this.onetimesalesItem &&
          this.onetimesalesItem.chargesData[0] &&
          this.onetimesalesItem.chargesData[0].chargeCode +
            "--" +
            this.onetimesalesItem &&
          this.onetimesalesItem.chargesData[0] &&
          this.onetimesalesItem.chargesData[0].chargeDescription;
        this.chargeCode =
          this.onetimesalesItem &&
          this.onetimesalesItem.chargesData[0] &&
          this.onetimesalesItem.chargesData[0].chargeCode;
      } catch (error) {
        console.log(
          "something went to wrong while retrieving entity city:",
          error
        );
      }
    },
    async orderQuantityChange() {
      let payload = {
        data: {
          locale: "en",
          quantity: this.orderQuantity,
          unitPrice: this.onetimesalesItem.unitPrice,
        },
        id: this.onetimesalesItem.id,
      };
      this.PriceData = await getTotalPricePost(payload);
      this.chargeAmount = this.PriceData.data.totalPrice;
      this.currencyId = this.PriceData.data.currencyId;
      if (this.discount != "") {
        let discountAmount = (this.chargeAmount * this.discount) / 100;
        this.chargeAmount = this.chargeAmount - discountAmount;
      }
    },
    backToGoods() {
      // this.$router.push("/inventory/stocktransfer");
      this.itemId = "";
      this.onetimesalesItem.unitPrice = "";
      this.chargeCode = "";
      this.currencyId = "";
      this.entity.officeId = "";
      this.entity.toofficeId = "";
      this.orderQuantity = "";
      this.chargeAmount = "";
      this.discount = "";
      this.loc = "";
      this.loc1 = "";
    },
    async CreateItemSale() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      let payload = {
        itemId: this.itemId,
        unitPrice: this.onetimesalesItem.unitPrice,
        chargeCode: this.chargeCode,
        currencyId: this.currencyId,
        purchaseFrom: this.entity.officeId,
        purchaseBy: this.entity.toofficeId,
        orderQuantity: this.orderQuantity,
        chargeAmount: this.chargeAmount,
        discount: this.discount,
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        purchaseDate: moment(this.purchaseDate).format("DD MMMM YYYY"),
      };
      await postItemSale(payload);
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Item Sale Created Successfully!",
        type: "success",
      });
      this.$router.push("/inventory/stocktransfer");
    },
  },
  watch: {
    itemSales(val) {
      for (let role of val.itemDatas) {
        this.itemList.push(role.itemCode + " -- " + role.itemDescription);
      }
    },
    discount(val) {
      if (val == "") {
        //
      } else {
        let discountAmount = (this.chargeAmount * this.discount) / 100;
        this.chargeAmount = this.chargeAmount - discountAmount;
      }
    },
  },

  mounted() {
    this.itemSaleTemplateResource();
  },
};
</script>
<style scoped></style>
